import { PMLineChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { theme } from "../../../theme";
import { DashboardCardContext } from "../context";

export function addCompletionPerMaturityLineCard(ctx: DashboardCardContext) {
  const { view, language } = ctx;

  const completionPerMaturityLineComponent = view.addComponent({
    component: PMLineChartCard,
    layoutProps: {
      componentId: "completionPerMaturityLineComponent",
      labels: ["lineChart", "chart", "completion", "maturity"],
      title:
        getLocalizedMessage(
          language,
          "cards.completionPerMaturityLine.title"
        ) || "Completion by Maturity",
      description:
        getLocalizedMessage(
          language,
          "cards.completionPerMaturityLine.description"
        ) || "Shows completed activities per maturity out of total activities.",
    },
  });

  completionPerMaturityLineComponent.mapLayoutProps(({ language }) => ({
    componentId: "completionPerMaturityLineComponent",
    labels: ["lineChart", "chart", "completion", "maturity"],
    title:
      getLocalizedMessage(language, "cards.completionPerMaturityLine.title") ||
      "Completion by Maturity",
    description:
      getLocalizedMessage(
        language,
        "cards.completionPerMaturityLine.description"
      ) || "Shows completed activities per maturity out of total activities.",
  }));

  completionPerMaturityLineComponent.mapState(
    ({ dashboard, settings, language }) => {
      const items =
        dashboard?.projects?.flatMap(
          (project) => project.reportingItems ?? []
        ) ?? [];

      const maturityEntries = (
        settings?.configuration?.maturityConfiguration ?? []
      )
        .slice()
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .filter((entry) => Boolean(entry.name));

      const categories = maturityEntries.map((entry) => entry.name ?? "");

      const completedDegreeName = (
        settings?.configuration?.degreeOfCompletionDefinition ?? []
      ).find((entry) => entry.order === 2)?.name;

      const totalPerMaturity = categories.map(
        (maturityName) =>
          items.filter(
            (item) => (item.basicItem?.maturity ?? "") === maturityName
          ).length
      );

      const completedPerMaturity = categories.map(
        (maturityName) =>
          items.filter(
            (item) =>
              (item.basicItem?.maturity ?? "") === maturityName &&
              (item.degreeOfCompletion ?? "") === (completedDegreeName ?? "")
          ).length
      );

      return {
        title:
          getLocalizedMessage(
            language,
            "cards.completionPerMaturityLine.title"
          ) || "Completion by Maturity",
        description:
          getLocalizedMessage(
            language,
            "cards.completionPerMaturityLine.description"
          ) ||
          "Shows completed activities per maturity out of total activities.",
        icon: "ShowChart",
        chartType: 2,
        categories,
        series: [
          {
            name: getLocalizedMessage(language, "total") || "Total",
            data: totalPerMaturity,
            color: theme.palette.text.secondary,
          },
          {
            name: getLocalizedMessage(language, "completed") || "Completed",
            data: completedPerMaturity,
            color: theme.palette.success.main,
          },
        ],
        xLabel: getLocalizedMessage(language, "maturity") || "Maturity",
        yLabel: getLocalizedMessage(language, "items") || "Items",
      };
    }
  );

  completionPerMaturityLineComponent.mapVisibility(({ settings }) => {
    return settings?.configuration?.useCase === "maturity";
  });
}
